import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { y: 2, width: 20, height: 2, rx: 1, fill: "#042F3C" }), /* @__PURE__ */ React.createElement("rect", { y: 9, width: 20, height: 2, rx: 1, fill: "#042F3C" }), /* @__PURE__ */ React.createElement("rect", { y: 16, width: 20, height: 2, rx: 1, fill: "#042F3C" }));
const ForwardRef = forwardRef(SvgHamburger);
export default ForwardRef;
